<template>
    <div id="header-main">
        <div class="logo-box" :key="showIndex">
            <div :class="local_la['logo-content']">
                <img :src="local_la['logoSrc']" alt="" class="pict">
            </div>
        </div>
        <div :class="local_la['title-box']">
            <div class="title-head" @click="changeTitle(0)">
                <p :class="[local_la['en-title'] , { 'title-span': currentIndx == 0 }]">{{ local_la['首页'] }}</p>
            </div>
            <div class="title-head" @click="changeTitle(1)">
                <p :class="[local_la['en-title'] , { 'title-span': currentIndx == 1 }]">{{ local_la['产品'] }}</p>
            </div>
            <div class="title-head" @click="changeTitle(2)">
                <p :class="[local_la['en-title'] , { 'title-span': currentIndx == 2 }]">{{ local_la['购买'] }}</p>
            </div>
            <div class="title-head" @click="changeTitle(3)">
                <p :class="[local_la['en-title'] , { 'title-span': currentIndx == 3 }, local_la['title-about']]">{{ local_la['关于我们'] }}</p>
            </div>
            <!-- <div :class="local_la['title-head']" @click="changeTitle(0)">
                <p :class="[local_la['head-1'], { 'title-span': currentIndx == 0 }]" >{{ local_la['首页'] }}</p>
                <div :class="['head-content',{'mobile-title-span-box': currentIndx == 0 }, { 'title-span': currentIndx == 0 }]">
                    <p style="title-border"></p>
                </div>
            </div>
            <div :class="local_la['title-head']" @click="changeTitle(1)">
                <p :class="[local_la['head-2'], { 'title-span': currentIndx == 1 }]">{{ local_la['产品'] }}</p>
                <div :class="['head-content', {'mobile-title-span-box': currentIndx == 1 } , { 'title-span': currentIndx == 1 }]">
                    <p style="title-border"></p>
                </div>
            </div>
            <div :class="local_la['title-head']" @click="changeTitle(2)">
                <p :class="[local_la['head-3'], { 'title-span': currentIndx == 2 }]">{{ local_la['购买'] }}</p>
                <div :class="['head-content',{'mobile-title-span-box': currentIndx == 2 }, { 'title-span': currentIndx == 2 }]">
                    <p style="title-border"></p>
                </div>
            </div>
            <div :class="local_la['title-head']" @click="changeTitle(3)">
                <p :class="[local_la['head-4'], { 'title-span': currentIndx == 3 }]">{{ local_la['关于我们'] }}</p>
                <div :class="['head-content',{'mobile-title-span-box-long': currentIndx == 3 }, {'mobile-title-span-box': currentIndx == 3 }, , { 'title-span': currentIndx == 3 }]">
                    <p style="title-border"></p>
                </div>
            </div> -->
        </div>
        <!-- <div :class="local_la['change-en']" >
            <span @click="changeEn(0)" :class="{ spantitle: currentEn == 0 }">{{ local_la['简'] }}</span> | <span @click="changeEn(1)" :class="{ spantitle: currentEn == 1 }" >EN</span>
        </div> -->
    </div>
</template>

<script>

export default ({
    data(){
        return{
            currentEn: 0,
            currentIndx: 0,
            logoSrc: "../../static/img/h5_logocn_top.png",
            ZH_la: {
                "logoSrc": "../../static/img/h5_logocn_top.png",
                "首页": "首页",
                "产品": "产品",
                "购买": "购买",
                "关于我们": "关于我们",
                "简": "简",
                "head-1": "head-1",
                "head-2": "head-2",
                "head-3": "head-3",
                "head-4": "head-4",
                "change-en": "change-cn",
                "mobile-title-span-box": "mobile-title-span-box-cn",
                "logo-content": "logo-content",
                "title-head": "title-head",
                "en-title": "en-title-cn",
                "title-about": "title-about-cn",
                "title-box": "title-box-cn",
            },
            EN_la: {
                "logoSrc": "../../static/img/h5_logoen_top.png",
                "首页": "HOME",
                "产品": "PRODUCTS",
                "购买": "PRICING",
                "关于我们": "ABOUT US",
                "简": "CN",
                "head-1": "head-1-en",
                "head-2": "head-2-en",
                "head-3": "head-3-en",
                "head-4": "head-4-en",
                "change-en": "change-en",
                "mobile-title-span-box": "mobile-title-span-box",
                "logo-content": "logo-content-en",
                "title-head": "title-head-en",
                "en-title": "en-title",
                "title-about": "title-about",
                "title-box": "title-box",
            },
            local_la: {

            },
        }
    },
    created(){
        this.changeHead();
        this.currentIndx = localStorage.getItem('indexPage');
    },
    methods: {
        changeEn: function(msg){
            this.currentEn = msg;
            if(this.currentEn == 0){
                this.$store.commit("ChangeLanguageState", false);
                localStorage.setItem('indexEn', 0)
            } else {
                this.$store.commit("ChangeLanguageState", true);
                localStorage.setItem('indexEn', 1)
            }
            this.changeHead()
        },
        changeTitle: function(msg){
            this.currentIndx = msg;
            if(msg == 0){
                this.$router.push("/");
                localStorage.setItem('indexPage', 0)
            } else if(msg == 1){
                this.$router.push("/product");
                localStorage.setItem('indexPage', 1)
            } else if(msg == 2){
                this.$router.push("/purchase");
                localStorage.setItem('indexPage', 2)
            } else if(msg == 3){
                this.$router.push("/about");
                localStorage.setItem('indexPage', 3)
            }
        },
        changeHead: function(){
            var indexEn = localStorage.getItem('indexEn')
            if(indexEn == null){
                this.$store.state.languageState = indexEn
                this.currentEn = indexEn;
            } else {
                

                this.$store.state.languageState = false
                this.currentEn = 0;
            }
            // 根据local_la确定字符串和图片的显示
            if (this.$store.state.languageState == false){
                this.local_la = this.ZH_la;
            } else {
                this.local_la = this.EN_la;
            }
        },
    },
    computed: {
        showIndex: function() {
            this.$store.state.pageIndex = this.currentIndx;
            return this.$store.state.pageIndex;
        }
    },
    watch:{
        $route() {   
            // 回到顶部
            this.currentIndx = localStorage.getItem('indexPage')
        }
    }
    // mounted() {
    //     window.addEventListener('load', () => { // 滚动事件变为 scroll
    //         if (this.$route.path !== '/') { // /print 表示首页
    //                 this.$router.replace('/') // 切换到首页
    //         }
    //     })
    // }
})
</script>


<style scoped>
#header-main{
    height: 10vw;
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    position: fixed;
    z-index: 300;
    background:#fff;
    margin-top: -1vw;
    /* padding-bottom: 1vw; */
}
.logo-content{
    width: 19.07vw;
	height: 3.24vw;
    /* margin-left: 1vw; */
    margin-right: 17vw;
    margin-top: 4vw;
    display: flex;
    justify-content: center;
    align-self: flex-start;
}
.logo-content-en{
    width: 19.07vw;
	height: 3.24vw;
    margin-left: 1vw;
    margin-right: 3vw;
    margin-top: 4vw;
    display: flex;
    justify-content: center;
    align-self: flex-start;
}
.title-box{
    display: flex;
    align-content: space-between;
    justify-content: space-between;
    width: 57vw;
    margin-right: 3vw;
}
.title-box-cn{
    display: flex;
    align-content: space-between;
    justify-content: space-between;
    width: 45vw;
}
.title-head:hover{
    cursor: pointer;
}
.title-head{
    color: #535c68;
    
    font-size: 0.75rem;
	font-weight: normal;
	font-stretch: normal;
	line-height: 4.78vw;
	letter-spacing: 0vw;
    color: #535c68;
    margin-top: 1vw;
    display: flex;
    align-self: center;
}
.title-head-en{	
    font-size: 0.5rem;
	font-weight: normal;
	font-stretch: normal;
	line-height: 4.78vw;
	letter-spacing: 0vw;
    color: #535c68;
    display: flex;
    align-self: center;
}
.head-1{
    width: 5.68vw;
	height: 2.69vw;
	
	font-size: 2.78vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.78vw;
	letter-spacing: 0vw;
    /* margin-bottom: 0.7vw; */
    padding-bottom: 0.5vw;
}
.head-2{
    width: 5.68vw;
	height: 2.69vw;
	
	font-size: 2.78vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.78vw;
	letter-spacing: 0vw;
    /* margin-bottom: 0.7vw; */
    padding-bottom: 0.5vw;
}
.head-3{
    width: 5.68vw;
	height: 2.69vw;
	
	font-size: 2.78vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.78vw;
	letter-spacing: 0vw;
    /* margin-bottom: 0.7vw; */
    padding-bottom: 0.5vw;
}
.head-4{
    width: 11.43vw;
	height: 2.59vw;
	
	font-size: 2.78vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.78vw;
	letter-spacing: 0vw;
	color: #535c68;
    /* margin-bottom: 0.7vw; */
    padding-bottom: 0.5vw;
}
.head-1-en{
    width: 8.5vw;
	height: 2.13vw;
	
	font-size: 2.78vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.78vw;
	letter-spacing: 0vw;
    /* margin-bottom: 1.2vw; */
    margin-right: 2.33vw;
    margin-top: 1.5vw;
    margin-bottom: 0.7vw;
    padding-bottom: 0.5vw;
}
.head-2-en{
    width: 14.98vw;
	height: 2.13vw;
	
	font-size: 2.78vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.78vw;
	letter-spacing: 0vw;
    /* margin-bottom: 1.2vw; */
    margin-right: 2.33vw;
    margin-top: 1.5vw;
    margin-bottom: 0.7vw;
    padding-bottom: 0.5vw;
}
.head-3-en{
    width: 11.28vw;
	height: 2.13vw;
	
	font-size: 2.78vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.78vw;
	letter-spacing: 0vw;
    /* margin-bottom: 1.2vw; */
    margin-right: 2.33vw;
    margin-top: 1.5vw;
    margin-bottom: 0.7vw;
    padding-bottom: 0.5vw;
}
.head-4-en{
    width: 14.46vw;
	height: 2.13vw;
	
	font-size: 2.78vw;
	font-weight: normal;
	font-stretch: normal;
	line-height: 2.78vw;
	letter-spacing: 0vw;
	color: #535c68;
    /* margin-bottom: 1.2vw; */
    margin-right: 2.33vw;
    margin-top: 1.5vw;
    margin-bottom: 0.7vw;
    padding-bottom: 0.5vw;
}
.head-content{
    margin-top: -2.5vw;
}
.mobile-title-span-box-en{
    width: 60%;
    margin-left: 20%;
    border-bottom: 0.5vw solid #1880ff;
    text-align: center;
    /* margin-top: -2vw; */
    margin-top: -1.5vw;
}
.mobile-title-span-box{
    width: 70%;
    margin-left: 10%;
    border-bottom: 0.5vw solid #1880ff;
    text-align: center;
    /* margin-top: -1.5vw; */
}
/* .mobile-title-span-box-long{
    width: 60%;
    margin-left: 10%;
    border-bottom: 0.5vw solid #1880ff;
    text-align: center;
    margin-top: -2vw;
} */
.title-span{
    color: #1880ff;
    border-bottom: 0.4vw solid #1880ff;
}

.change-en{
	width: 10.98vw;
	/* height: 2.41vw; */
	
    font-size: 0.75rem;
	
	font-weight: normal;
	font-stretch: normal;
	line-height: 4.78vw;
	letter-spacing: 0vw;
	color: #535c68;
    display: flex;
    align-self: center;
    margin-left: 3.15vw;
    margin-top: 1vw;
    
}
.change-cn{

	font-size: 0.75rem;
	font-weight: normal;
	font-stretch: normal;
	line-height: 4.78vw;
	letter-spacing: 0vw;
    color: #535c68;
    display: flex;
    align-self: center;
    margin-left: 3.15vw;
    margin-top: 1vw;
}
.spantitle{
    color: #1880ff;
}
.pict{
    width: 100%;
    height: auto;
}
.en-title-cn{

}
.en-title{
    margin-right: 1.24vw;
}
.title-about{
    width: 16.5vw;
    text-align: center;
}
.title-about-cn{

}
</style>






// WEBPACK FOOTER //
// src/components/H5Header.vue